<template>
  <div class="acomodar">
    <button
      v-if="preguntas"
      class="btn btn-danger mx-4 my-2"
      @click="retroceder"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        class="bi bi-skip-backward"
        viewBox="0 0 16 16"
      >
        <path
          d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"
        />
      </svg>
      RETROCEDER
    </button>

    <h2 v-if="preguntas" class="mx-4 mt-2 text-secondary">
      ETAPA CAPACITACIONES SST
    </h2>
    <h5 v-if="preguntas" class="mx-4 mt-4 titulo">
      CAPACITACIONES EN SEGURIDAD Y PREVENCION DEL COVID
    </h5>

    <div v-if="preguntas" class="px-4 pt-5">
      <div class="row gx-4 gy-4 ">
        <div
          v-for="(capacitacion, index) in des[0].titulo"
          :key="index.id"
          class="col-lg-4 "
        >
          <!-- {{des[0].cabeceraVideo[index]}} -->

          <!-- <p v-if="nota[index] == des[0].cabeceraVideo[index]"></p>   -->
          <div  class="shadow-lg p-3 mb-5 bg-white h-100 rounded text-center">
            <h6 class="mt-2 mb-5 tituloColor">
              {{ capacitacion }}
            </h6>

            <p v-if="apagado">cargando....</p>

            <iframe
              v-else
              :src="des[0].linksVideo[index]"
              class="img-fluid"
              width="500"
              height="375"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>

            <button 
              class="btn btn-ligth border border-2 mt-3 tamaño-nota text-dark mt-2"
            >
              {{ nota[index] }}
            </button>

            <button
              class="btn btn-success mx-2 mt-4 text-white mt-2"
              v-if="botonPregunta"
              :disabled="botonPregunta"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                class="bi bi-play-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"
                />
              </svg>
              cargando.....
            </button>

            <button
              class="btn btn-success mx-2 mt-4 text-white mt-2"
              v-if="!botonPregunta && permisoVisualizador == 2"
              @click="
                EnviarPreguntas(des[0].cabeceraVideo[index], capacitacion)
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-pen"
                viewBox="0 0 16 16"
              >
                <path
                  d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"
                />
              </svg>
              REALIZAR EXAMEN
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="px-4 pt-3 mb-5">
      <button class="btn btn-danger" @click="regreso">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          fill="currentColor"
          class="bi bi-skip-backward"
          viewBox="0 0 16 16"
        >
          <path
            d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"
          />
        </svg>
        RETROCEDER
      </button>

      <div class="px-4 pt-3 mb-5">
        <!-- <button v-if="spinner" @click="apreder">aplicar</button> -->
        <div>
          <h3 class="mt-3 titulo2">{{ tituloCapacitacion }}</h3>
        </div>
        <!-- <p v-if="spinner">cargando....</p> -->

        <form action="" @submit.prevent="eventos">
          <div v-for="(items, index) in apiPregunta" :key="index.id">
            <input
              type="checkbox"
              class="mt-3 mx-2"
              :value="items.idDetVideo"
              @change="preguntasMarcada(items.nroPregunta)"
              v-model="picked1"
              v-if="items.alternativa != 0"
              
            />

            <label class="mt-4" :class="{'tamaño' : items.alternativa == 0 }"> {{ items.vidPreguntaDes }} </label>
           
          </div>

          <button type="submit" class="btn btn-success mt-5" :disabled="TiempoDeCarga">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              fill="currentColor"
              class="bi bi-save2 mx-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
              /></svg>GUARDAR RESPUESTAS
          </button>
        </form>
  
      </div>
    </div>
    <div v-if="mensaje" class="container mt-5 w-100">
        <h3 class="text-center mt-3">No hay videos Disponibles...</h3>
      </div>

  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "SolimanologDatosCapacitacion",

  data() {
    return {
      mensaje:false,
      preguntas: true,
      apagado: true,
      TiempoDeCarga:false,
      spinner: true,
      items: [],
      titulo: [],
      videosUrl: [],
      pregunta: [],
      cabeceraId: [],
      tituloCapacitacion: "",
      des: [
        {
          titulo: [],
          linksVideo: [],
          nombreVideo: [],
          numeroPregunta: [],
          cabeceraVideo: [],
        },
      ],
      isdisabled: true,
      picked1: [],
      preguntara: [],
      nota: [],
      botonPregunta: true,

      form: {
        idUsuario: "",
        idSolxPostulante: "",
        idCabVideo: "",
        vidPreNumero: "",
        detVideo: "",
      },
      apiPregunta: [],
      preguntasResponder: [],
      permisoVisualizador: null,
      numero: [],
    };
  },

  async mounted() {
    this.form.idUsuario = localStorage.getItem("userId");
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.form.idSolxPostulante = this.$route.params.ContraVid;

    await this.axios
      .get("VidCapacitacion/CapxPostulante/" + this.$route.params.ContraVid)
      .then((r) => {
        console.log(r.data);
        if(r.data.length == 0){
          this.mensaje = true
          this.cubo = false
        }

        this.botonPregunta = false;

        this.items = r.data;
        this.apagado = false;
        for (let itema of r.data) {
          this.titulo.push(itema.nomVideo);
          this.videosUrl.push(itema.videolink);
          this.pregunta.push(itema.numPregunta);
          this.cabeceraId.push(itema.idCabVideo);

          this.des[0].titulo = this.titulo.filter((item, index) => {
            return this.titulo.indexOf(item) === index;
          });

          this.des[0].linksVideo = this.videosUrl.filter((item, index) => {
            return this.videosUrl.indexOf(item) === index;
          });

          this.des[0].numeroPregunta = this.pregunta.filter((item, index) => {
            return this.pregunta.indexOf(item) === index;
          });

          this.des[0].cabeceraVideo = this.cabeceraId.filter((item, index) => {
            return this.cabeceraId.indexOf(item) === index;
          });
        }
      });

    for (let iteracion of this.des[0].cabeceraVideo) {
      await this.axios
        .get(
          `VidCapacitacion/ObtenerNotas?idSolxPostulante=${this.$route.params.ContraVid}&idVideo=${iteracion}`
        )
        .then((r) => {
          this.nota.push(r.data);
        });
    }
  },

  methods: {
    async Notas() {
      for (let iteracion of this.des[0].cabeceraVideo) {
        await this.axios
          .get(
            `VidCapacitacion/ObtenerNotas?idSolxPostulante=${this.$route.params.ContraVid}&idVideo=${iteracion}`
          )
          .then((r) => {
            this.nota.push(r.data);
          });
      }
    },

    retroceder() {
      window.history.back();
    },

    EnviarPreguntas(nroPregunta, titulo) {
      this.tituloCapacitacion = titulo;
      this.form.idCabVideo = nroPregunta;
      this.preguntas = false;
      this.axios
        .get(
          `VidCapacitacion/PreguntasxVideo/${this.form.idCabVideo}`
        )
        .then((r) => {
          this.apiPregunta = r.data;
          this.spinner = true;
        });
    },

    regreso() {
      this.preguntas = !this.preguntas;
      this.Notas();
      this.picked1 = [];
      this.preguntara = [];
      this.preguntasResponder = [];
      this.numero= []

    },

    preguntasMarcada(event) {
      this.preguntara.push(event);
    },

    eventos() {
      this.TiempoDeCarga = true;
      let arreglo1 = this.preguntara.sort(function (a, b) {
        return a - b;
      });

      let arreglo2 = this.picked1.sort(function (a, b) {
        return a - b;
      });

      let array1 = arreglo1.filter((item, index) => {
        return arreglo1.indexOf(item) === index;
      });

      this.form.vidPreNumero = `${array1}`;
      this.form.detVideo = `${arreglo2}`;
      console.log(this.form.vidPreNumero);
      console.log(this.form.detVideo);

      for (let i of this.apiPregunta) {
        this.numero.push(i.nroPregunta);
      }



      let numeroPreguntas = Math.max(...this.numero);
      if (
        arreglo2.length == numeroPreguntas &&
        array1.length == numeroPreguntas
      ) {
        
          this.axios
          .post("VidCapacitacion/RegistrarRespuestas", this.form)
          .then((r) => {
            if (r.data == true) {
              // this.Notas()
              
            setTimeout(() => {
        this.TiempoDeCarga = false;
      }, 5000); 
              Swal.fire({
                position: "center",
                icon: "success",
                title: "¡SE REGISTRARON SUS RESPUESTAS!",
                showConfirmButton: true,
                
              });
              this.picked1 = [];
              this.numero = [];


            }
          });
      }
        
        

      if (arreglo2.length === 0 || arreglo2.length < numeroPreguntas) {

        Swal.fire({
          title: "¡SE DEBE REALIZAR TODAS LAS PREGUNTAS!",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });

        this.TiempoDeCarga = false;


      }

      if (
        arreglo2.length > numeroPreguntas ||
        this.form.vidPreNumero.length < numeroPreguntas
      ) {

        Swal.fire({
          title: "¡SE DEBE MARCAR UNO POR PREGUNTA!",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
        this.TiempoDeCarga = false;
      }
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y: none;
}

.titulo {
  font-size: 0.94rem;
}

.titulo2 {
  color: #0080c8;
  text-decoration: underline;
}

.preguntas {
  color: #002c5d;
  font-size: 1.05rem;
  font-weight: 600;
}
.tituloColor {
  font-weight: 500;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  color: #002c5d;
}

.tamaño-nota {
  font-size: 1.06rem;
}

.tamaño{
  font-size: 0.65rem;
  font-weight: 600;
  color: rgb(24, 83, 248)
}
</style>
